import NetworkBase from "../common/NetworkBase";

export default class PaymentService extends NetworkBase {
    getOrderId(postdata) {
   
    let url =`${this.apibasepath()}assign-fee-component-with-payment-link`;
    let that = this;
    return new Promise(function (resolve, reject) {
      that
        .postRequest(url, postdata)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  }

  rejectOrder(postdata) {
   
    let url =`${this.apibasepath()}payments/online/reject/order`;
    let that = this;
    return new Promise(function (resolve, reject) {
      that
        .patchRequest(url, postdata)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  capturePayment(postdata) {
   
    let url =`${this.apibasepath()}payments/capture`;
    let that = this;
    return new Promise(function (resolve, reject) {
      that
        .postRequest(url, postdata)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAmount(enquiryCode) {
    let url = `${this.apibasepath()}get-class-amount-enquirycode?enquiryCode=${enquiryCode}`;
    // let LevelsDataUrl = "../JSON/leveldata.json";
    
    let that = this;
    return new Promise(function (resolve, reject) {
      that
        .getRequest(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          //console.log('getLevelsData API error:', error);
          reject(error.response);
        });
    });
  }








}
